// Formats a byte count as a human-readable size (B/KB/MB/GB), shared by both frontends so the
// staff drop zone and the external upload page display sizes identically.
export function formatFileSize(bytes: number): string {
  if (bytes <= 0) {
    return "0 B";
  }
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}
